// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDXY5F4Rd4HL-gWQ_X7t_x78ZOqrTZQ1r4",
  authDomain: "superdub-bc81f.firebaseapp.com",
  projectId: "superdub-bc81f",
  storageBucket: "superdub-bc81f.appspot.com",
  messagingSenderId: "69055413092",
  appId: "1:69055413092:web:123584f6f273c6ff331871",
  measurementId: "G-66REDG4Y52"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export default auth;